import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import CommentForm, { TFormDataComment } from '../form/CommentForm';

type TProps = {
  replyForm: UseFormReturn<TFormDataComment>;
  isReplyValid: boolean;
  isReplyFocused: boolean;
  setIsReplyFocused: (focused: boolean) => void;
  onSubmitReply: (e?: React.BaseSyntheticEvent) => void;
};

const ReplyInput = ({ replyForm, isReplyValid, isReplyFocused, setIsReplyFocused, onSubmitReply }: TProps) => {
  // Dismiss handler for replies: clears text, blur
  const onDismiss = () => {
    replyForm.reset({ text: '' });
    setIsReplyFocused(false);
  };

  return (
    <div className="pt-4 w-full">
      <CommentForm
        form={replyForm}
        isFocused={isReplyFocused}
        setIsFocused={setIsReplyFocused}
        isValid={isReplyValid}
        onSubmit={onSubmitReply}
        onDismiss={onDismiss}
        autoFocus={false}
      />
    </div>
  );
};

export default ReplyInput;
